import { render, staticRenderFns } from "./AmountDetailDeposit.vue?vue&type=template&id=d15e6e92&scoped=true&"
import script from "./AmountDetailDeposit.vue?vue&type=script&lang=ts&"
export * from "./AmountDetailDeposit.vue?vue&type=script&lang=ts&"
import style0 from "./AmountDetailDeposit.vue?vue&type=style&index=0&id=d15e6e92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15e6e92",
  null
  
)

export default component.exports